import api from "../../API/apiConfig";

// 1. Lấy danh sách Opportunities
export const getOpportunities = async () => {
  return await api.get(`/opportunities/list`);
};
// 2. Lấy danh sách Opportunities theo roles
export const getOpportunitiesFilter = async (filters = {}) => {
  const { pageNo = 0, pageSize = 10, property = "id", direction = "ASC", ...otherFilters } = filters;
  return await api.get(`/opportunities`, {
    params: { 
      pageNo, 
      pageSize, 
      property, 
      direction,
      ...otherFilters
    },
  });
};

// 2. Thêm mới Opportunity
export const addOpportunity = async (opportunityData) => {
  return await api.post("/opportunities/add-opportunity", opportunityData);
};

// 3. Cập nhật Opportunity theo ID
export const updateOpportunity = async (id, opportunityData) => {
  return await api.put(`/opportunities/update/${id}`, opportunityData);
};

// 4. Xóa Opportunity theo ID
export const deleteOpportunity = async (id) => {
  return await api.delete(`/opportunities/delete/${id}`);
};

// 5. Xem chi tiết một Opportunity theo UUID
export const getOpportunityDetail = async (uuid) => {
  return await api.get(`/opportunities/${uuid}/view`);
};
// 6. Lấy tất cả các tags ra cho người dùng chọn
export const getAllTags = async () => {
  return await api.get(`tags/list-all`);
}
// 7. Lấy ra tất cả các stage cho người dùng chọn
export const getTypePipeline = async (type) => {
  return await api.get(`/pipelines/${type}`);
};
//8. Lấy ra tất cả contact dựa trên Account cho Opportunity đó
export const getAllContacts = async (accountId) => {
  return await api.get(`contacts/list-all?accountId=${accountId}`);
}
//9. Update thông tin 1 contact role nào đó
export const updateSingleContactRole = async (contactRoleId, updateData) => {
  return await api.put(`opportunities/update-single-contact/${contactRoleId}`, updateData);
}
//10. Lấy thông tin của 1 contact role
export const getSingleContactRoleData = async (contactRoleId) => {
  return await api.get(`opportunities/contact-role/detail/${contactRoleId}`);
}
//11. Xóa 1 contact role ra khỏi oppor đó
export const deleteContactRole = async (contactRoleId) => {
  return await api.delete(`opportunities/delete-contact/${contactRoleId}`);
}
//12. Thêm contact role cho Oppor 
export const addContactRole = async (opportunityId, contactData) => {
  return await api.put(`opportunities/update-contact/${opportunityId}`, contactData);
}
//13. Lấy tất cả pricebook cho người dùng chọn
export const getAllPricebooks = async () => {
  return await api.get(`/price_books/list-all`);
};
//14. Add PriceBook cho Deals
export const addPriceBook = async (opportunityId, priceBookId) => {
  return await api.post(`/opportunities/add-price-book/${opportunityId}?priceBookId=${priceBookId}`);
};
//15. Lấy tất cả product dựa trên Price Book
export const getAllProductsBasedOnPriceBook = async (priceBookId) => {
  return await api.get(`/product_price_books?priceBookId=${priceBookId}`);
};
//16. Thêm Product cho opportunity
export const addProductToOppotunity = async (opportunityId, productOpportunityData) => {
  return await api.post(`/opportunities/add-product/${opportunityId}`, productOpportunityData);
};
//17. Delete Product khỏi opportunity
export const deleteProductFromOpportunity = async(opportunityProductId) => {
  return await api.delete(`opportunities/delete-product/${opportunityProductId}`);
}
//18. Update Price Book from Opportunity
export const updatePriceBookFromopportunity = async (opportunityId, priceBookId) => {
  return await api.put(`opportunities/update-price-book/${opportunityId}?priceBookId=${priceBookId}`);
}

//19. Tạo quotes
export const addQuote = async (params) => {
  return await api.post(`/quotes/add`, params);
};
//20. Get quotes
export const getQuote = async (opportunityId) => {
  return await api.get(`/quotes/${opportunityId}`);
};
//15. Product Price Book Detail
export const getProductPriceBookDetail = async (productPriceBookId) => {
  return await api.get(`/product_price_books/detail/${productPriceBookId}`);
};
//16. Update status
export const updateStatus = async (id, stageId) => {
  return await api.put(`/opportunities/update-status/${id}`, stageId );
};
//21. Oppor Kanban
export const getOpportunityKanban = async () => {
  return await api.get(`/opportunities/kanban`);
};
//22. Xem chi tiết sản phẩm trong 1 opportunity
export const getOpportunityProductDetail = async (opportunityProductId) => {
  return await api.get(`/opportunities/detail-product/${opportunityProductId}`);
};
//23. Update sản phẩm trong 1 opportunity
export const updateOpportunityProductDetail = async (opportunityProductId, data) => {
  return await api.put(`/opportunities/update-product/${opportunityProductId}`, data);
};
//24. Sync Price
export const syncOpportunityProductPrice = async (opportunityId) => {
  return await api.post(`/opportunities/sync-amount/${opportunityId}`);
};

//25 . Get Accessibility cho Opportunity
export const getAccessibilityForOppor = async (id) => {
  return await api.get(`/opportunities/accessibility/${id}`);
};

//26. Update Accessibility cho Opportunity
export const updateAccessibilityForOppor = async (id, data) => {
  return await api.post(`/opportunities/update-access/${id}`, data);
};
//27. Change Owner
export const changeOwner = async (opportunityIds, newOwnerUuid) => {
  return await api.put("/opportunities/change-owner", { opportunityIds, newOwnerUuid });
};

